export default __webpack_public_path__ + "static/media/av4.fe520b36.jpg";